export default {
  'processNotification.title': 'Listado de Notificaciones Personalizadas',

  'notification.status.execution': 'Ejecución',
  'notification.status.approved': 'Aprobada',
  'notification.status.rejected': 'Rechazada',
  'notification.status.canceled': 'Cancelada',
  'notification.status.voided': 'Anulada',
  'notification.addedUsers': 'Usuario Agregado',
  'processNotification.form.isSendToApplicantEnabled': '¿Enviar al Solicitante?',
};
